if (!customElements.get('card-media-slider')) {
  customElements.define(
    'card-media-slider',
    class CardMediaSlider extends HTMLElement {
      connectedCallback() {
        this.init(0);
      }

      disconnectedCallback() {
        if (this.hintObserver) this.hintObserver.disconnect();
        clearTimeout(this.hintTimer);
        if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
        this.swiper = null;
      }

      // Swiper is loaded from a CDN with defer, so wait for it (cards can also be added later by filters / load more)
      init(attempt) {
        if (this.swiper) return;
        if (!window.Swiper) {
          if (attempt < 60) setTimeout(() => this.init(attempt + 1), 100);
          return;
        }

        const container = this.querySelector('.card-media-slider__swiper');
        if (!container) return;

        this.userInteracted = false;
        this.swiper = new window.Swiper(container, {
          slidesPerView: 1,
          speed: 350,
          // Endless in both directions: on the first image the user can swipe either way
          loop: true,
          watchOverflow: true,
          simulateTouch: false,
          nested: true,
          touchStartPreventDefault: false,
          navigation: {
            prevEl: this.querySelector('.card-media-slider__arrow--prev'),
            nextEl: this.querySelector('.card-media-slider__arrow--next'),
          },
          on: {
            // Only real user input counts: in loop mode Swiper fires slideChange by itself on init
            touchStart: () => {
              this.userInteracted = true;
            },
          },
        });

        this.querySelectorAll('.card-media-slider__arrow').forEach((arrow) => {
          arrow.addEventListener('click', () => {
            this.userInteracted = true;
          });
        });

        if (this.hasAttribute('data-hint')) this.setupHint();
      }

      setupHint() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.hintObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.hintObserver.disconnect();
            this.hintTimer = setTimeout(() => this.playHint(), 900);
          },
          { threshold: 0.6 }
        );
        this.hintObserver.observe(this);
      }

      // Slide the first image a third of the way and back, to show that the images can be swiped.
      // Uses setTransition/setTranslate instead of translateTo: translateTo sets swiper.animating = true
      // and never resets it, and in loop mode that blocks the arrows for good (loopPreventsSlide).
      playHint() {
        const swiper = this.swiper;
        if (!swiper || swiper.destroyed || this.userInteracted || swiper.realIndex !== 0) return;
        if (!swiper.slides || swiper.slides.length < 2) return;

        // In loop mode the first image is not at translate 0, so move relative to the current position
        const duration = 450;
        const start = swiper.getTranslate();
        const stillIdle = () => !swiper.destroyed && !this.userInteracted && swiper.realIndex === 0;

        swiper.setTransition(duration);
        swiper.setTranslate(start - swiper.width / 3);

        this.hintTimer = setTimeout(() => {
          if (!stillIdle()) return;
          swiper.setTransition(duration);
          swiper.setTranslate(start);
          this.hintTimer = setTimeout(() => {
            if (!swiper.destroyed && !this.userInteracted) swiper.setTransition(0);
          }, duration + 50);
        }, duration + 250);
      }
    }
  );
}
